/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { ColCard } from "../../../components/ContentLayout";
import PurchaseSalesPieChart from "../../../components/Dashboard/PurchaseSalesPieChart";
import SalaryBarChart from "../../../components/Dashboard/SalaryBarChart";
import SalesBarChart from "../../../components/Dashboard/SalesBarChart";
import PageHeader from "../../../components/PageHeader"
import CardUsedPieChart from "./CardUsedPieChart";
import BankTransPieChart from "./BankTransPieChart";
// import useWindowSize from "../../../hooks/useWindowSize";
import MonthlyProfitLossChart from "./MonthlyProfitLossChart";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { permissionCheck } from "../../../utils/permission";

const FundsReport = (props) => {
  const history = useHistory()
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'FUND_REPORT')
      setTargetPermission(permission)
      if (isEmpty(permission)) {
        permissionCheck(history, "FUND_REPORT")
      }
    }
  }, [permissions])

  return (
    !isEmpty(targetPermission) && (
      <div className="funds-report-page">
        <PageHeader title={"리포트"} />
        <div className="funds-report-container">
          <div className="funds-report-top-wrap">
            <ColCard
              type="light"
              md="12"
            >
              <SalesBarChart isYearRange />
            </ColCard>
          </div>
          <div className="funds-report-middle-wrap">
            <div className="purchase-sales-wrap item-box">
              <ColCard
                type="light"
                md="12"
              >
                <PurchaseSalesPieChart isYearRange />
              </ColCard>
            </div>
            <div className="salary-wrap item-box">
              <ColCard
                type="light"
                md="12"
              >
                <SalaryBarChart />
              </ColCard>
            </div>
            <div className="monthly-profit-loss-wrap item-box">
              <ColCard
                type="light"
                md="12"
              >
                <MonthlyProfitLossChart />
              </ColCard>
            </div>
          </div>
          <div className="funds-report-bottom-wrap">
            <ColCard
              type="light"
              md="12"
            >
              <CardUsedPieChart />
            </ColCard>
            <ColCard
              type="light"
              md="12"
            >
              <BankTransPieChart />
            </ColCard>
          </div>
        </div>
      </div>)
  );
};

export default FundsReport;
